export default {
  id: null,
  pastaPaiID: null,
  empresaID: null,
  nome: null,
  caixaPasta: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/foldermodel.js